import React from "react";
import SafetyIcon from "../../../assets/images/safety-icon.svg";
import FastTransferIcon from "../../../assets/images/fast-transfer-icon.svg";
import BestExchangeRate from "../../../assets/images/best-exchange-rate-icon.svg";

const ChooseRemit = () => {
  const details = [
    {
      icon: SafetyIcon,
      title: "Safe",
      subtitle:
        "100% secure & regulated by FCA",
    },
    {
      icon: FastTransferIcon,
      title: "Fast Transfer",
      subtitle:
        "Transfer is done instantly",
    },
    {
      icon: BestExchangeRate,
      title: "Best Exchange Rate",
      subtitle:
        "We have the best exchange rate in the market",
    },
    // {
    //   title: "Multiple channels of remittance",
    //   subtitle:
    //     "It’s your money. You can choose however you would like to send or receive it: mobile top-up, cash pickups, mobile wallets, and direct bank transfer.",
    // },
    // {
    //   title: "Secure platform",
    //   subtitle:
    //     "your financial data is encrypted and our services are consistently available.",
    // },
    // {
    //   title: "Competitive exchange rates",
    //   subtitle:
    //     "We offer our customers the cheapest rates available in the markets. Spend less; send more. ",
    // },
  ];
  return (
    <div className="py-5 bg-primary text-white chooseIleeroRemit" id="choose-ileero-remit">
      <div className="row justify-content-center my-5">
        <div className="col-lg-6 text-center">
          <h1 className="font-weight-bold">
            Why choose Ileero Remit
          </h1>
        </div>
      </div>

      <div className="container">
        <div className="row">
          {details.map((detail, index) => (
            <div key={index} className="col-lg-4 my-4 text-center">
              <img className="mb-4" src={detail.icon} alt={detail.title} />
              <h5 className="font-weight-bold">{detail.title}</h5>
              <p>{detail.subtitle}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChooseRemit;
